"use client";

import { useEffect, useState } from 'react';
import useIsMobile from '@/app/hooks/useIsMobile';
import useTranslations from '@/app/hooks/useTranslation';
import Footer from './footer';

// Client component wrapper for Footer
export default function FooterClient() {
    const isMobile = useIsMobile();
    const { language, translations } = useTranslations();
    const [mounted, setMounted] = useState(false);

    // Prevent hydration mismatch
    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    // Default footer padding - reduced to prevent too much space
    const footerPadding = isMobile ? "3rem" : "7rem";

    return (
        <Footer 
            isMobile={isMobile} 
            language={language} 
            translations={translations} 
            footerPadding={footerPadding} 
        />
    );
}

